import { render } from "./ChangeRequest.vue?vue&type=template&id=a7e2df7c&scoped=true"
import script from "./ChangeRequest.vue?vue&type=script&lang=js"
export * from "./ChangeRequest.vue?vue&type=script&lang=js"

import "./ChangeRequest.vue?vue&type=style&index=0&id=a7e2df7c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7e2df7c"]])

export default __exports__